<template>
  <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.999 3.75L13.4142 13.1082L3 14.6183L10.5442 21.9938L8.7408 32.25L17.999 27.3144L27.2591 32.25L25.4689 21.9938L33 14.6183L22.6435 13.1082L17.999 3.75Z"
      :fill="status ? '#FFD000' : '#f4f6f5'"
      :stroke="status ? '#FFD000' : '#f4f6f5'"
      stroke-width="2"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'StarIcon',
  props: {
    status: {
      type: Boolean,
      default: false,
    },
  },
  setup() {},
})
</script>
